import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/operator/catch';
import { KeywordService } from '../../../api/keyword/keyword.service';
import { KeywordModel } from '../../../api/keyword/KeywordModal';

import { MasterDataConstant } from '../../../api/masterdata.constant';

declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'keyword-page',
    templateUrl: './keyword.html'
})
export class KeywordComponent implements OnInit {
    keywordList: KeywordModel[];
    iKeyword: KeywordModel;
    message: string;
    id: string;
    keyword: string = "";
    value: string = "";
    description: string = "";
    iIndex: number
    private sub: any;
    appSKU: string = "";
    appId: string = "";
    apptype: string = "";
    jsondata: string;
    jsonkeywords = [];

    selectVersion : string = "2";

    constructor(
        private masterdataservice : MasterDataConstant,
        private activatedRoute: ActivatedRoute,
        private keywordservice: KeywordService,
        private router: Router) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' || localStorage.getItem('type') == 'DEVELOPER')) {
            this.sub = this.activatedRoute.params.subscribe(params => {
                this.appSKU = params['id1'];
                this.appId = params['id2'];
                this.apptype = params['id3'];
                $(function () {
                })
                this.initData();
            });
        } else {
            this.router.navigate(['/']);
        }
    }
    initData() {
        var aData = {
            sku: this.appSKU,
            type: this.apptype,
            version : this.selectVersion
        }
        this.keywordservice.allKeyword(aData)
            .then(data => {
                this.keywordList = data
                this.jsonkeywords = [];
                if (this.keywordList.length > 0) {
                    for (var i = 0; i < this.keywordList.length; i++) {
                        var temp = new Object();
                        temp['keyword'] = this.keywordList[i].keyword;
                        temp['value'] = this.keywordList[i].value == null ? "" : this.keywordList[i].value;
                        temp['description'] = this.keywordList[i].description == null ? "" : this.keywordList[i].description;
                        this.jsonkeywords.push(temp);
                    }
                    this.jsondata = JSON.stringify(this.jsonkeywords);
                } else {
                }
            });
    }
    cancelAction() {
        this.keyword = "";
        this.value = "";
        this.description = "";
    }
    submitKeyword() {
        if (this.keyword == undefined || this.keyword == "") {
            $.notify({
                message: "Please Enter Keyword."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        let iKeyword = {
            keyword: this.keyword,
            value: this.value,
            description: this.description,
            applicationId: this.appId,
            sku: this.appSKU,
            type: this.apptype,
            version : this.selectVersion
        }
        this.keywordservice
            .inKeyword(iKeyword)
            .then(data => {
                if (data.status) {
                    this.message = data.message
                            this.initData();
                            $.notify({
                                message: this.message
                            }, {
                                type: 'success',
                                placement: {
                                    from: 'bottom',
                                    align: 'left'
                                },
                                delay: 100,
                                timer: 100
                            });
                            $(function () {
                                $("#example3").modal('toggle');
                            });
                            if(this.keyword == "KDefaultCountry")
                            {
                                this.masterdataservice.CountryList = [];
                            }
                            this.cancelAction();
                } else {
                    this.message = data.message
                    $.notify({
                        message: this.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    showKeyword(index, keyword) {
        this.iIndex = index;
        this.id = keyword.id;
        this.keyword = keyword.keyword;
        this.value = keyword.value;
        this.description = keyword.description;
    }
    updateKeyword() {
        if (this.keyword == undefined || this.keyword == "") {
            $.notify({
                message: "Please Enter Keyword."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            return;
        }
        var ukeyword = {
            sku : this.appSKU,
            keyword: this.keyword,
            value: this.value,
            description: this.description
        }
        if (this.id == 'undefined') {
            $.notify({
                message: 'Refresh Data'
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 100
            });
            this.cancelAction();
        }
        else {
            this.keywordservice.uKeyword(this.id, ukeyword)
                .then(data => {
                    if (data.status == true) {
                        this.initData();
                                $.notify({
                                    message: data.message
                                }, {
                                    type: 'success',
                                    placement: {
                                        from: 'bottom',
                                        align: 'left'
                                    },
                                    delay: 100,
                                    timer: 100
                                });
                                $(function () {
                                    $('#exampleModal').modal('toggle');
                                });
                                if(this.keyword == "KDefaultCountry")
                                {
                                    this.masterdataservice.CountryList = [];
                                }
                                this.cancelAction();
                    } else {
                        $.notify({
                            message: data.message
                        }, {
                            type: 'danger',
                            placement: {
                                from: 'bottom',
                                align: 'left'
                            },
                            delay: 100,
                            timer: 100
                        });
                    }
                });
        }
    }
    deleteKeyword() {
        this.keywordservice
            .dKeyword(this.id)
            .then(data => {
                if (data.status) {
                    this.initData();
                    $.notify({
                        message: data.message
                    }, {
                        type: 'success',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                    $(function () {
                        $('#deleteModal').modal('toggle');
                    });
                } else {
                    $.notify({
                        message: data.message
                    }, {
                        type: 'danger',
                        placement: {
                            from: 'bottom',
                            align: 'left'
                        },
                        delay: 100,
                        timer: 100
                    });
                }
            });
    }
    onVersionChange(ver) {
        this.selectVersion = ver;
        this.initData();
    }
    checkJson() {
        try {
            JSON.parse(this.jsondata);
        } catch (e) {
            return false;
        }
        return true;
    }
    submitJson() {
        let check = this.checkJson()
        let compare = false;
        if (check) {
            let jsonData = JSON.parse(this.jsondata)
            for (var i = 0; i < jsonData.length; i++) {
                for (var j = i + 1; j < jsonData.length; j++) {
                    if (jsonData[j].keyword == jsonData[i].keyword) {
                        compare = true;
                        break;
                    } 
                    else 
                    {
                        compare = false;
                    }
                }
                if (compare == true) {
                    break;
                }
            }
            if (compare == false) {
                var JData = {
                    applicationId: this.appId,
                    sku: this.appSKU,
                    type: this.apptype,
                    jsonArray: JSON.parse(this.jsondata)
                }
                this.keywordservice.iJsonKeyword(JData).then(data => {
                    if (data.status) {
                        this.initData();
                        $(function () {
                            $('#jsonViewModel').modal('toggle');
                        });
                    }
                });
            }
            else {
                $.notify({
                    message: "Duplicate Values are present in keyword data."
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 200
                });
            }
        } else {
            $.notify({
                message: "Invalid Json."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 200
            });
        }
    }
    updateJson() {
        let check = this.checkJson()
        let compare = false;
        if (check) {
            let jsonData = JSON.parse(this.jsondata)
            for (var i = 0; i < jsonData.length; i++) {
                for (var j = i + 1; j < jsonData.length; j++) {
                    if (jsonData[j].keyword == jsonData[i].keyword) {
                        compare = true;
                        break;
                    } else {
                        compare = false;
                    }
                }
                if (compare == true) {
                    break;
                }
            }
            if (compare == false) {
                this.submitJson();
            } else {
                $.notify({
                    message: "Duplicate Values are present in keyword data."
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 200
                });
            }
        } else {
            $.notify({
                message: "Invalid Json."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 200
            });
        }
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/application/keyword.page.ts